import React, { Component } from 'react'
import { getDatetime } from './../../utils/js/time_helpers'
import { env_url } from './../../utils/js/endpoints'
import { fireAnalytics } from '../../utils/js/analytic_helpers'
import { formatLeagueDisplayName } from '@digitalmedia/sn-design-system'

import './Event.scss'

class Event extends Component {
    constructor() {
        super()
        this.broadcasters = {
            CBC: [
                14173,
                114,
                3942,
                3321,
                10883,
                3322,
                3323,
                119,
                6803,
                132,
                6804,
                121,
                8376,
                6805,
                4885,
                7389,
                7588,
                225,
                6806,
                2720,
                34,
                3929,
                2826,
                14858,
                610,
                13588,
                107,
                4022,
                200,
                6807,
                49,
                6808,
                147,
                6809,
                180,
                3930,
                6257,
                110,
                3941,
                6810,
                146,
                8385,
                6811,
                7369,
                8626,
                8627,
                8027,
                8028,
                3320,
                572,
                231,
                485,
                142,
                7951,
                152,
                9206,
                348,
                202,
                25,
                1228,
                74,
                6421,
            ],
            City: [
                2186,
                257,
                8488,
                240,
                7595,
                2813,
                1171,
                6603,
                6139,
                10292,
                241,
                11455,
                42,
                3935,
                2825,
                187,
                8374,
                3936,
                230,
                6799,
                13869,
                13870,
                19890,
            ],
            OLN: [160, 9505],
            RNL: [],
            'SN Canucks': [8628, 8630],
            'SN Flames': [8489, 8491],
            'SN NOW': [],
            'SN NOW+': [],
            'SN Oil': [8492, 8493],
            'SN World': [
                4442,
                14145,
                20335,
                14146,
                20336,
                14147,
                20337,
                14148,
                20338,
                14149,
                20339,
                14150,
                20340,
                14151,
                20341,
                14152,
                20342,
                14153,
                20343,
                8431,
            ],
            SN: [],
            'SN.ca': [],
            SN1: [8249, 19279, 8359],
            SN360: [336, 3614],
            SN3604K: [],
            SN4K: [19278],
            SN14K: [19279],
            SNE: [255, 332, 16161, 6043],
            SNO: [254, 299, 331, 16162, 300, 6044],
            SNP: [314, 253, 16163, 6042],
            SNW: [252, 2703, 2704, 2705, 16164, 6041],
        }
    }

    render() {
        const { event, channels, aniDelay } = this.props

        let time_now = Math.floor(Date.now() / 1000)

        let live =
            (event.game_status === 'In-Progress' ||
                (time_now > event.start_time_utc && time_now < event.end_time_utc)) &&
            event.game_status !== 'Final'

        let img_silhouette = `${env_url}/schedule_default.png`

        let background_image = event.arena_background_image
            ? event.arena_background_image
            : event.promo_image
            ? event.promo_image
            : ''
        let visiting_team_image = event.visiting_team_image || null
        let home_team_image = event.home_team_image || null
        let add_overlay_class =
            (visiting_team_image && home_team_image) || live ? 'add_overlay' : ''
        let featured = (event.priority_level && event.priority_level === 'Featured') || null
        let regional_restriction = event.regional_restriction || false
        let time = getDatetime(event.start_time_utc, 'time_wo_timezone')
        let deep_link_web = live && event.deep_link_web ? event.deep_link_web : null
        let featured_class = featured ? 'featured_game' : ''
        let primary_broadcaster = event.primary_broadcaster || ''
        let primary_broadcast_logo =
            (event.primary_broadcaster && event.primary_broadcaster_img_reverse_svg) || ''
        let secondary_broadcaster = event.secondary_broadcaster || ''
        let secondar_broadcast_logo =
            (event.secondary_broadcaster && event.secondary_broadcaster_img_reverse_svg) || ''
        let tertiary_broadcaster = event.tertiary_broadcaster || ''
        let tertiary_broadcast_logo =
            (event.tertiary_broadcaster && event.tertiary_broadcaster_img_reverse_svg) || ''
        let all_channels = []

        if (channels.length !== 0) {
            // SN is not an actual channel so we must assume SNO to grab correct channels
            primary_broadcaster = primary_broadcaster === 'SN' ? 'SNO' : primary_broadcaster
            secondary_broadcaster = secondary_broadcaster === 'SN' ? 'SNO' : secondary_broadcaster
            tertiary_broadcaster = tertiary_broadcaster === 'SN' ? 'SNO' : tertiary_broadcaster

            let primary_channels = primary_broadcaster
                ? channels.filter(channel => {
                      return (
                          this.broadcasters[primary_broadcaster] &&
                          this.broadcasters[primary_broadcaster].indexOf(channel.stationID) !== -1
                      )
                  })
                : []

            let secondary_channels = secondary_broadcaster
                ? channels.filter(channel => {
                      return (
                          this.broadcasters[secondary_broadcaster] &&
                          this.broadcasters[secondary_broadcaster].indexOf(channel.stationID) !== -1
                      )
                  })
                : []

            let tertiary_channels = tertiary_broadcaster
                ? channels.filter(channel => {
                      return (
                          this.broadcasters[tertiary_broadcaster] &&
                          this.broadcasters[tertiary_broadcaster].indexOf(channel.stationID) !== -1
                      )
                  })
                : []

            all_channels = [...primary_channels, ...secondary_channels, ...tertiary_channels]
            all_channels = all_channels.map(channel => channel.channelNumber)
            all_channels = [...new Set(all_channels)] //remove duplicates
            all_channels = all_channels.sort((a, b) => a - b).slice(0, 8) // sort asc with max of 8 elements
        }

        return (
            <div className="Event__cont" style={{ animationDelay: `${aniDelay}s` }}>
                <div className="inner_event_cont">
                    <div className="main_image_cont">
                        <div
                            className={`background_image ${add_overlay_class} ${featured_class}`}
                            style={{
                                backgroundImage: `url(${
                                    background_image ? background_image : img_silhouette
                                })`,
                            }}
                        />
                        <div className="content_overlay_cont">
                            <div className="matchup_overlay">
                                {visiting_team_image && <img src={visiting_team_image} alt="" />}
                                {deep_link_web && (
                                    <a
                                        href={deep_link_web}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <button
                                            className="play_icon"
                                            onClick={() => {
                                                fireAnalytics(
                                                    'show select',
                                                    'event play card',
                                                    0,
                                                    deep_link_web,
                                                    'Sportsnet Now',
                                                    'ANALYTIC_EVENT_BROADCAST_SCHEDULE'
                                                )
                                            }}
                                        >
                                            <div className="triangle" />
                                        </button>
                                    </a>
                                )}
                                {home_team_image && <img src={home_team_image} alt="" />}
                            </div>
                        </div>
                    </div>
                    <div className={`event_content ${featured_class}`}>
                        <div className="event_status_cont">
                            {featured && (
                                <div className="priority featured_game">
                                    <span>Featured Game</span>
                                </div>
                            )}
                            {live && (
                                <div className="priority live">
                                    <span>Live</span>
                                </div>
                            )}
                            {regional_restriction && (
                                <div className="priority regional_restriction">
                                    <span>Regional Restriction</span>
                                </div>
                            )}
                            {!live && <div className="time">{time}</div>}
                        </div>
                        <div className="sport_league_cont">
                            {event.league && (
                                <div className="league">
                                    {formatLeagueDisplayName(event.league)}
                                </div>
                            )}
                            {event.sport && <div className="sport">{event.sport}</div>}
                        </div>
                        {event.event_name && <div className="event_name">{event.event_name}</div>}
                        <div className="broadcast_logos_cont">
                            <div className="logo_cont">
                                <img src={primary_broadcast_logo} alt={primary_broadcaster} />
                            </div>
                            {secondar_broadcast_logo && <div className="border" />}
                            {secondar_broadcast_logo && (
                                <div className="logo_cont">
                                    <img
                                        src={secondar_broadcast_logo}
                                        alt={secondary_broadcaster}
                                    />
                                </div>
                            )}
                            {tertiary_broadcast_logo && <div className="border" />}
                            {tertiary_broadcast_logo && (
                                <div className="logo_cont">
                                    <img src={tertiary_broadcast_logo} alt={tertiary_broadcaster} />
                                </div>
                            )}
                        </div>
                        {all_channels.length !== 0 && (
                            <div className="mychannels">
                                My Channels: <span>{all_channels.join(', ')}</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default Event
